<template>
  <div class="c-circle-wrap">
    <svg class="svg" width="100%" height="100%" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <circle
        :cx="size / 2 * ratio"
        :cy="size / 2 * ratio"
        :r="r"
        :stroke-width="transThick"
        stroke="#dedede"
        fill="none"
        stroke-linecap="round"
      />
      <circle
        v-if="sl>0"
        :cx="size / 2 * ratio"
        :cy="size / 2 * ratio"
        :r="r"
        :stroke-width="transThick"
        :stroke="color"
        fill="none"
        stroke-linecap="round"
        :stroke-dasharray="dasharray"
      />
    </svg>
    <div class="info" v-if="percentValue != ''">{{percentValue}}%</div>
    <div class="info" v-else>{{value}}/{{total}}</div>
  </div>
</template>

<script>
export default {
  props: {
    thick: {
      type: Number,
      default: 4,
    },
    color: {
      type: String,
      default: '#f50',
    },
    size: {
      type: Number,
      default: 100,
    },
    percentValue: {
      type: [Number, String],
      default: '',
    },
    total: {
      type: Number,
      default: 100,
    },
    value: {
      type: Number,
      default: 20,
    },
  },
  data() {
    return {
      transThick: 4,
      percent: 0,
      arcType: 0,
      r: 50,
      l: 0,
      sl: 0,
      dasharray: '',
      ratio: 1,
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.r = 46
      this.calMobilePixel()
      this.calPercent()
      this.l = this.r * 2 * Math.PI
      this.sl = this.l * this.percent
      this.dasharray = this.sl + ',' + this.l * 2
    },
    calMobilePixel() {
      let docEl = document.documentElement
      this.ratio = docEl.clientWidth >= 540 ? 0.72 : docEl.clientWidth / 750
      console.log(this.ratio)
      this.r = this.ratio * this.r
      this.transThick = this.ratio * this.thick
    },
    calPercent() {
      if (this.percentValue) {
        if (isNaN(this.percentValue)) {
          this.percent = 1
        }
        if (this.percentValue < 100) {
          this.percent = this.percentValue / 100
        } else {
          this.percent = 1
        }
      } else {
        let p = this.value / this.total
        if (isNaN(p)) {
          this.percent = 1
        }
        this.percent = p
      }
    },
  },
}
</script>

<style scoped lang="less">
.svg {
  transform: rotate(-90deg);
}
.c-circle-wrap {
  position: relative;
  width: 100px;
  height: 100px;
  overflow: hidden;
}
.circle {
  overflow: hidden;
  width: 100%;
  height: 100%;
  /* mask的计算半价为准 */
  -webkit-mask: radial-gradient(transparent 43px, #000 46px);
  mask: radial-gradient(transparent 43px, #000 46px);
  overflow: hidden;
  border-radius: 50%;
  position: relative;
}

.circle-left {
  width: 51%;
  height: 100%;
  background: #e8e8e8;
  transform-origin: 100% 50%;
  position: absolute;
  left: 0;
  z-index: 0;
}

.circle-right {
  width: 50%;
  height: 100%;
  background: #e8e8e8;
  transition: transform 1s linear;
  transform-origin: 0% 50%;
  position: absolute;
  right: 0;
  z-index: 2;
}

.circle-bottom-left {
  width: 50%;
  height: 100%;
  background: #f50;
  position: absolute;
  left: 0;
  z-index: -1;
}

.circle-bottom-right {
  width: 50%;
  height: 100%;
  background: #f50;
  position: absolute;
  right: 0;
  z-index: 1;
}

.info,
.info2 {
  width: 100%;
  text-align: center;
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
  font-size: 26px;
  color: #ff5500;
  font-weight: 500;
}
.info2 {
  line-height: 26px;
}
</style>